import { useState, useEffect, useContext } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { usePDF, Resolution, Margin } from "react-to-pdf";

import {
    MdOutlineLocalPrintshop,
    MdOutlineFactCheck,
    MdOutlineSend,
    MdOutlineTextIncrease,
    MdOutlineTextDecrease,
    MdOutlineFileDownload,
    MdModeEdit,
} from "react-icons/md";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { PiPaperclip } from "react-icons/pi";

import "./css/view.css";

import { AppContext } from "../../Context";
import Question from "./components/question";
import { Loader, GET, permissions } from "../../inc/Fetch";
import Header from "./Header";
import PrintView from "./components/PrintView";
import Permission from "../Permission";
import { RiUserVoiceLine } from "react-icons/ri";
import { FaRegStickyNote } from "react-icons/fa";

export default function Start({ action }) {
    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();

    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    const [show, setshow] = useState(0);
    const [answers, setanswers] = useState({});

    const { toPDF, targetRef } = usePDF({
        filename: "yallangany.pdf",
        resolution: Resolution.HIGH,
        method: "open",
        page: {
            // margin is in MM, default is Margin.NONE = 0
            margin: Margin.SMALL,
        },
    });

    const [showanswers, setshowanswers] = useState("");
    const [fontsize, setfontsize] = useState(12);
    const [activity, setactivity] = useState(false);
    const [loader, setloader] = useState(false);
    const [isLoading, setisLoading] = useState(true);
    const [data, setdata] = useState({});
    const [allowResults, setallowResults] = useState(false);

    async function loadData() {
        let r = await GET(`task/loadTask/?_id=${params?.id}`);
        setisLoading(false);
        setdata(r);
    }

    // const { data, error, isLoading } = useQuery(`task-${params?.id}`, loadData);

    function showAnswers() {
        setshowanswers((p) => !p);
    }

    function fontSizeCg(st) {
        if (st) {
            setfontsize((p) => (p <= 12 ? 12 : p - 2));
        } else {
            setfontsize((p) => (p >= 18 ? 18 : p + 2));
        }
    }

    function saveAnswers(d, k) {
        setanswers((p) => ({
            ...p,
            [k]: d,
        }));
    }

    function downloadPdf() {
        toPDF();
        // setloader(true);
        // setTimeout(() => {
        //     setloader(false);
        // }, 4000);
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        const handleGlobalClick = (event) => {
            // Check if the click (or any of its parents) has the class
            const btn = event.target.closest(".playVideo");

            if (btn) {
                const videoBox = btn.closest(".teacherVideoBox");
                const video = videoBox.querySelector("video");

                video.play();
                videoBox.classList.add("is-playing");

                // Your logic here
            }
        };

        // 3. Attach the listener if the element exists
        document.addEventListener("click", handleGlobalClick);

        return () => {
            document.removeEventListener("click", handleGlobalClick);
        };
    }, []);

    if (isLoading) {
        return <Loader />;
    }

    if (!userinfo?._id) {
        return <Permission />;
    } else {
        let perms = permissions(
            userinfo,
            params?.id,
            data?.task?.cat?._id,
            data?.task?.lesson ? "tasks" : "tasks_send",
        );
        if (!perms) {
            return <Permission />;
        }
    }

    return (
        <>
            {loader && <Loader />}
            <div className="taskNewBody">
                <Header />

                <div className="rightTaskMenu">
                    {data?.task?.notes && (
                        <Link
                            tabIndex="0"
                            to={`/task_notes`}
                            state={{
                                previousLocation: location,
                                notes: data?.task?.notes,
                            }}
                            // onClick={showAnswers}
                            style={{
                                backgroundColor: "#1acca3",
                                paddingTop: 9,
                            }}
                        >
                            <FaRegStickyNote style={{ color: "#fff" }} />
                            <span>{t("tasks_send_notes")}</span>
                        </Link>
                    )}
                    <a
                        tabIndex="0"
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                showAnswers();
                            }
                        }}
                        onClick={showAnswers}
                    >
                        <MdOutlineFactCheck
                            style={{ color: showanswers ? "#1acca3" : "" }}
                        />
                        <span>{t("task_start_opt_6")}</span>
                    </a>

                    <a tabIndex="0" onClick={() => setallowResults((p) => !p)}>
                        <RiUserVoiceLine
                            style={{ color: allowResults ? "#1acca3" : "" }}
                        />
                        <span>{t("task_start_opt_9")}</span>
                    </a>

                    {data?.task?.user?._id == userinfo?._id && (
                        <Link
                            tabIndex="0"
                            to={`/${data?.task?.lesson ? "lesson" : "task"}/new/${data?.task?.cat?.name}/${params?.id}`}
                            className="admin"
                        >
                            <MdModeEdit />
                            <span>{t("task_start_opt_1")}</span>
                        </Link>
                    )}

                    {data?.task?.files?.length ? (
                        <Link
                            tabIndex="0"
                            to={`/tasksPapger/${params?.id}`}
                            state={{
                                previousLocation: location,
                                papers: data?.task?.files,
                            }}
                        >
                            <PiPaperclip />
                            <span>{t("task_attached_files")}</span>
                        </Link>
                    ) : (
                        false
                    )}

                    <Link
                        target="_blank"
                        tabIndex="0"
                        to={`/task/print/${params?.id}/print`}
                    >
                        <MdOutlineLocalPrintshop />
                        <span>{t("task_start_opt_4")}</span>
                    </Link>

                    <Link tabIndex="0" onClick={() => downloadPdf()}>
                        <MdOutlineFileDownload />
                        <span>{t("task_start_opt_5")}</span>
                    </Link>

                    <a
                        tabIndex="0"
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                fontSizeCg();
                            }
                        }}
                        onClick={() => fontSizeCg()}
                    >
                        <MdOutlineTextIncrease />
                        <span>{t("task_start_opt_7")}</span>
                    </a>
                    <a
                        tabIndex="0"
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                fontSizeCg(true);
                            }
                        }}
                        onClick={() => fontSizeCg(true)}
                    >
                        <MdOutlineTextDecrease />
                        <span>{t("task_start_opt_8")}</span>
                    </a>
                </div>

                <div className={`mainWidth taskMainNewBox f-${fontsize}`}>
                    <div className="mainTitleBox">
                        <div>
                            <h1 className="mainTitle">{data?.task?.title}</h1>
                            <nav>
                                <Link
                                    to={`/site/${data?.task?.cat?.name}/${data?.task?.lesson ? "lessons" : "tasks"}`}
                                    className="tagInfo"
                                >
                                    {data?.task?.cat?.name}
                                </Link>
                                {data?.task?.subject?.name ? (
                                    <Link
                                        style={{ background: "#1acca3" }}
                                        className="tagInfo"
                                    >
                                        {data?.task?.subject?.name}
                                    </Link>
                                ) : (
                                    false
                                )}

                                {data?.task?.classes?.map((v, k) => {
                                    return (
                                        <a key={k} className="tagInfo">
                                            {t("class")} {global?.Classes[v]}
                                        </a>
                                    );
                                })}
                            </nav>
                        </div>

                        <Link
                            to={`/sendTask/${params?.id}`}
                            state={{ previousLocation: location }}
                            className="btn sendTaskTo"
                        >
                            {t("tasks_send_now")}
                        </Link>
                    </div>

                    <div className="taskCreatorBox"></div>

                    {data?.task?.story && (
                        <div className="storySection shadow">
                            {userinfo?.userlevel >= 7 && (
                                <nav className="taskUserInfoBox">
                                    {data?.task?.user?.school?.name && (
                                        <a className="tag gray">
                                            {data?.task?.user?.school?.name}
                                        </a>
                                    )}
                                    <a
                                        target="_blank"
                                        href={`/cp/MoeUsers/add/${data?.task?.user?._id}`}
                                        className="tag gray"
                                    >
                                        {data?.task?.user?.name}
                                    </a>
                                </nav>
                            )}

                            <h6 className="sectionTigtle">
                                <div className="triangle-up"></div>
                                {data?.task?.lesson
                                    ? t("task_new_text")
                                    : t("task_new_task_text")}
                            </h6>
                            {data?.task?.story && (
                                <div
                                    style={{ whiteSpace: "pre-line" }}
                                    className="storyBoxText"
                                    dangerouslySetInnerHTML={{
                                        __html: data?.task?.story,
                                    }}
                                />
                            )}
                        </div>
                    )}

                    {data?.task?.questions?.length ? (
                        <div className="questionsBoxNewTitle">
                            <hr />
                            <span>
                                {t("tasks_questions_number")} (
                                {data?.task?.questions?.length})
                            </span>
                            <hr />
                        </div>
                    ) : (
                        false
                    )}

                    <div className="quizNewMainBox">
                        {data?.task?.questions?.map((v, k) => {
                            return (
                                <div className="storySection shadow grayBg">
                                    <Question
                                        k={k}
                                        response={(d) => saveAnswers(d, v?.id)}
                                        key={k}
                                        data={v}
                                        show={true}
                                        active={allowResults}
                                        showAnswers={showanswers || ""}
                                    />
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            <PrintView data={data} hidden={true} targetRef={targetRef} />
        </>
    );
}
